export const supportRequest = {
    breadcrumb: {
        supportRequest: 'Help',
    },
    table: {
        email: 'Email',
        phoneNumber: 'Phone Number',
        firstName: 'First Name',
        lastName: 'Last Name',
        category: 'Category',
        priority: 'Priority',
        version: 'Version',
        site: 'Site',
        object: 'Object',
        reference: 'Reference',
        detail: 'Detail',
        fileAttachment: 'File Attachment',
    },
    button: {
        export: 'Export CSV',
        edit: 'Exit',
        delete: 'Delete',
        save: 'Save',
        reset: 'Reset',
        linkFile: 'Click here',
        sendToSupport: 'Send to support',
    },
    placeholder: {
        export: 'Select export file',
    },
    title: {
        export: {
            span: 'Export list to: ',
            content: 'Choose an export format and save the file to your disk',
        },
    },
    list: {
        category: {
            incident: 'Incident',
            request: 'Request',
            idea_suggestion: 'Idea/Suggestion',
        },
        site: {
            spacialytic_platform: 'Spacialytic Platform',
            spacialytic_3dwebviewer: 'Spacialytic 3D Viewer',
            spacialytic_constellation: 'Spacialytic Constellation',
        },
        priority: {
            hight: 'High',
            medium: 'Medium',
            low: 'Low',
        },
    },
    form: {
        title: {
            create: 'Create support request',
            update: 'Update support request',
            detail: 'Support request detail',
        },
        email: {
            label: 'Email',
            placeholder: 'Select email',
        },
        phoneNumber: {
            label: 'Phone Number',
            placeholder: 'Enter phone number',
        },
        firstName: {
            label: 'First Name',
            placeholder: 'Enter first name',
        },
        lastName: {
            label: 'Last Name',
            placeholder: 'Enter last name',
        },
        object: {
            label: 'Object',
            placeholder: 'Enter object',
        },
        reference: {
            label: 'Reference',
            placeholder: 'Enter reference',
        },
        detail: {
            label: 'Detail',
            placeholder: 'Enter detail',
        },
        keyword: {
            placeholder: 'Enter keyword',
            label: 'Keyword',
        },
        category: {
            placeholder: 'Select category',
            label: 'Category',
        },
        site: {
            placeholder: 'Select site',
            label: 'Site',
        },
        priority: {
            placeholder: 'Select priority',
            label: 'Priority',
        },
        version: {
            placeholder: 'Enter version',
            label: 'Version',
        },
        file: {
            label: 'File Attachment',
            placeholder: 'Choose file',
        },
    },
    message: {
        delete: {
            confirmAsk: 'Are you sure you want to delete this support request?',
            title: 'Notification',
            success: 'Delete support request successfully',
        },
    },
    exportCSV: {
        success: 'We are exporting files, it may takes time, please come back later',
        error: {
            canNotExport: 'We can not export files',
            connectSocketFail: 'Connect socket server failed',
        },
        download: 'Downloading...',
    },
    sendEmail: 'Your support request has been sent to the administrator',
};
